import React, { useMemo } from "react";

import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";
import { useAdicionarUnidade } from "features/adicionar-unidade/hooks/useAdicionarUnidade";

import BillingData from "features/adicionar-unidade/steps/BillingData";
import DirectDebit from "features/adicionar-unidade/steps/DirectDebit";
import Meter from "features/adicionar-unidade/steps/Meter";
import Registration from "features/adicionar-unidade/steps/Registration";
import SuccessRegister from "features/adicionar-unidade/steps/SuccessRegister";

import {
  Container,
  CustomScroll,
  Divisor,
  Header,
  Title,
} from "./AdicionarUnidadePage.styles";

const AdicionarUnidadePage = (): JSX.Element => {
  const { step } = useAdicionarUnidade();

  const stepComponent = useMemo(() => {
    const components: Record<number, JSX.Element> = {
      1: <Registration />,
      2: <Meter />,
      3: <BillingData />,
      4: <DirectDebit />,
      5: <SuccessRegister />,
    };

    return components[step] || <Registration />;
  }, [step]);

  return (
    <Navbar selected="adicionar-nova-unidade">
      <UserMenu />
      <CustomScroll>
        <Container>
          <Header>
            <Title>Adicionar nova unidade</Title>
          </Header>
          <Divisor />
          {stepComponent}
        </Container>
      </CustomScroll>
    </Navbar>
  );
};

export default AdicionarUnidadePage;
